export default {
  Label_Common: {
    Dai_ChuShiHua: '待初始化',
    ZhengZai_ChuShiHua: '正在初始化',
    YiChang: '异常',
    ZhengChang_YingYe: '正常营业',
    TingZhi_YingYe: '停止营业',
    ZhenJiu_FanFa: '针灸方法',
    ZhenJiu_WeiZhi: '针灸位置',
    YaoPing_GongNeng: '药品功能',
    YaoPing_PingPai: '药品品牌',
    YaoPing_BiaoZhun: '药品标准',
    HuiYuan_LeiBie: '会员类别',
    ChaKan: '查看',
    QiTa_ZhuMing: '其他 · 请注明',
    HuaYan_LeiXing: '化验类型',
  },
}
